import React from 'react'
import cls from 'classnames'
import styled from 'styled-components'

import UpgradeLicenseModal from 'containers/UpgradeLicenseModal'

const mapColorByType = {
  upgrade: '#7BD2FC',
  upgrade_secondary: '#C5C7D0',
  primary: '#2E41EA',
  warning: '#FFA800',
}

const LargeBanner = ({
  className,
  text,
  subText,
  buttonText,
  type,
  Icon,
  iconSize,
  id,
  buttons,
  withUpgradeButton = true,
}) => (
  <div className={className}>
    <div className="flex-container">
      {type === 'upgrade' ? (
        <img src="/static/webapp/images/upgrade-icon.svg" className="upgrade-img" />
      ) : (
        <div className={cls('dib-vac', { 'with-background': type === 'primary' })}>
          <Icon size={iconSize || '28px'} fill={mapColorByType[type]} className="dib-vac" />
        </div>
      )}
      <div className="info-container dib-vac tal">
        <div className="main-text sb pc">
          {text || 'Upgrade your license to unlock unlimited capabilities'}
        </div>
        <div className="sub-text">
          {!!subText && subText}
          {type === 'upgrade_secondary' && (
            <UpgradeLicenseModal triggerText=" Click here" triggerTextColor="#00AFFF" id={id} />
          )}
        </div>
      </div>
    </div>

    {type === 'upgrade' && withUpgradeButton && (
      <div className="btn-side dib-vac tar">
        <UpgradeLicenseModal triggerText={buttonText || 'Upgrade Plan'} isButton id={id} />
      </div>
    )}
    {buttons}
  </div>
)

export default styled(LargeBanner)`
  box-sizing: border-box;
  margin-bottom: 25px;
  padding: 10px 17px 10px 12px;
  border: 1px solid ${(props) => mapColorByType[props.type]};
  border-left: 10px solid ${(props) => mapColorByType[props.type]};
  border-radius: 4px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .upgrade-img {
    width: 36px;
    height: 50px;
  }
  .with-background {
    padding: 10px;
    border-radius: 40px;
    background: #e6e9ff;
    line-height: 0;
  }
  .info-container {
    margin-left: 13px;
    .main-text {
      font-size: 14px;
    }
    .sub-text {
      color: #565b6d;
      font-size: 12px;
      margin-top: 3px;
    }
  }
  .btn-side {
    width: 215px;
  }
`
